<div class="modal user-guide-modal">
  <div class="modal-header user-guide-header align-items-start" jest-id="guide-header">
    <div class="d-flex w-100 align-items-start justify-content-between gap-3">
      <div class="d-flex flex-column gap-2">
        <div class="modal-title" jest-id="guide-title">{{ title }}</div>
        <p class="mb-0 text-body-tertiary">
          Find the main workflows in the portal, jump to the section you need, and use the links below to move around the
          guide without leaving the app.
        </p>
      </div>

      <div class="guide-header-actions">
        <button
          type="button"
          class="btn btn-light guide-action-btn"
          aria-label="Export user guide as PDF"
          title="Export user guide as PDF"
          jest-id="export-btn"
          (click)="onExportGuide()"
        >
          <svg-icon [src]="exportIcon?.svg" [applyClass]="true" class="mh-svg-body-primary" />
        </button>

        <button
          type="button"
          class="btn btn-light guide-action-btn"
          aria-label="Close user guide"
          jest-id="close-btn"
          (click)="onClose()"
        >
          <svg-icon [src]="closeIcon?.svg" [applyClass]="true" class="mh-svg-body-primary" />
        </button>
      </div>
    </div>
  </div>

  <div #dialogBody class="modal-body user-guide-body" jest-id="guide-body">
    <div class="guide-layout">
      <aside class="guide-sidebar">
        <section #tocAnchor id="user-guide-top" class="guide-toc" jest-id="guide-toc">
          <div class="d-flex flex-column gap-2">
            <h2 class="guide-section-title mb-0">Contents</h2>
            <p class="mb-0 text-body-tertiary">Select a section to scroll directly to that part of the guide.</p>
          </div>

          <div class="guide-toc-list">
            @for (section of sections; track section.id) {
              <button
                type="button"
                class="btn guide-toc-link"
                jest-id="toc-link"
                [attr.data-target-section]="section.id"
                (click)="scrollToSection(section.id)"
              >
                {{ section.title }}
              </button>
            }
          </div>
        </section>
      </aside>

      <div class="guide-content">
        @for (section of sections; track section.id) {
          <section
            class="guide-section"
            jest-id="guide-section"
            [attr.data-guide-section-id]="section.id"
            [attr.id]="section.id"
          >
            <div class="d-flex flex-column flex-md-row align-items-start justify-content-between gap-2">
              <div class="d-flex flex-column gap-2">
                <h2 class="guide-section-title mb-0">{{ section.title }}</h2>
                @if (section.intro) {
                  <p class="mb-0 text-body-secondary">{{ section.intro }}</p>
                }
              </div>

              <button
                type="button"
                class="btn btn-link guide-back-to-top p-0"
                jest-id="back-to-top"
                (click)="scrollToTop()"
              >
                Back to top
              </button>
            </div>

            <div class="guide-task-list">
              @for (task of section.tasks; track task.heading) {
                <article class="guide-task" jest-id="guide-task">
                  <h3 class="guide-task-title">{{ task.heading }}</h3>
                  <p class="mb-0">{{ task.body }}</p>

                  @if (task.bullets?.length) {
                    <ul class="guide-task-bullets">
                      @for (bullet of task.bullets; track bullet) {
                        <li>{{ bullet }}</li>
                      }
                    </ul>
                  }
                </article>
              }
            </div>

            @if (section.table) {
              <div class="guide-table-wrapper" jest-id="guide-table">
                <table class="guide-table">
                  <thead>
                    <tr>
                      @for (column of section.table.columns; track column) {
                        <th scope="col">{{ column }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of section.table.rows; track $index) {
                      <tr>
                        @for (cell of row; track $index) {
                          @if ($index === 0) {
                            <th scope="row">{{ cell }}</th>
                          } @else {
                            <td>{{ cell }}</td>
                          }
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </section>
        }
      </div>
    </div>
  </div>
</div>
